import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { InfiniteScrollContainer } from "./InfiniteScrollContainer";
export const InfiniteScrollSpinner = (param)=>{
    let { dataTestId } = param;
    return /*#__PURE__*/ _jsx(InfiniteScrollContainer, {
        children: /*#__PURE__*/ _jsx(Spinner, {
            className: "size-7 text-teal-9",
            "data-testid": dataTestId
        })
    });
};
